/*
 * @Date: 2020-03-09 21:30:19
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 17:35:23
 * @FilePath: /rongxin.web/src/views/home/swiper/index.js
 */

import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import Service from './servece';
export default {
  components: {
    swiper,
    swiperSlide
  },
  name: 'carrousel',
  data() {
    return {
      swiperOption: {
        init: false,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        observer: true,
        observerParents: true,
        speed: 500,
        slideClass: 'my-slide', // 区分首页管理团队再次引用swiper的类名冲突
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets'
        },
        navigation: {
          nextEl: '.my-button-next', // 区分首页管理团队再次引用swiper的类名冲突
          prevEl: '.my-button-prev'
        }
      },
      params: {
        limit: 'unlimited',
        status: 1, // 只查已启用
        clientId: '6188e0dbc2d92675c94f5598',
        catalogId: '6188e599c2d92675c94f5599',
        source: 'guanWang'
      },
      imgArr: [],
      total: 2
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    this.getAdvertisingList();
  },
  updated() {
    if(this.imgArr.length > 1) {
      this.swiper.init();
    }
  },
  methods: {
    mouseenter() {
      this.$refs.mySwiper.swiper.autoplay.stop();
    },
    mouseleave() {
      this.$refs.mySwiper.swiper.autoplay.start();
    },
    getAdvertisingList(){
      Service.getAdvertisingList(this.params).then(data => {
        if (data && data.data.result) {
          this.total = data.data.total;
          data.data.result.forEach(item => {
            this.imgArr.push({
              styles: {
                background: `url(${item.image}) no-repeat center top`,
                backgroundSize: 'cover'
              }
            });
          });
        }
      });
    }
  }
};
